import * as React from 'react';
import WorkFlowList from './Components/WorkFlowList';
import CustomMenu from '../../components/CustomMenu/CustomMenu';



/**
 * ワークフロー一覧ページ
 * - カスタムメニュー内にワークフロー一覧コンポーネントを表示する
 */
export default function WorkFlowPage() {
 
  
  return (
   <CustomMenu>
          <WorkFlowList/> 
    </CustomMenu>
       
    )}
    